<template>
  <div v-loading.fullscreen="loading">
    <div class="header-scroll">
      <div class="header">
        <el-select
          v-model="region_id"
          placeholder="Viloyatlar"
          @change="onChangeRegion"
          :loading="regionsLoading"
          clearable
          class="header-control"
        >
          <el-option value="" label="Barchasi" />
          <el-option
            v-for="region in regions"
            :key="region.id"
            :value="region.id"
            :label="region.title"
          />
        </el-select>

        <el-select
          v-model="district_id"
          placeholder="Tuman/Shahar"
          @change="onChangeDistrict"
          :loading="districtsLoading"
          clearable
          class="header-control"
        >
          <el-option value="" label="Barchasi" />
          <el-option
            v-for="district in districts"
            :key="district.id"
            :value="district.id"
            :label="district.title"
          />
        </el-select>

        <el-upload
          ref="uploadRef"
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeader"
          :multiple="false"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :limit="1"
          :on-exceed="onExceed"
          :on-success="onSuccessUpload"
          :on-error="onErrorUpload"
        >
          <template #trigger>
            <el-button style="width: 100%" type="primary">
              Deputatlarni Excel orqali kiritish
            </el-button>
          </template>
        </el-upload>

        <el-button type="success" class="header-button" @click="downloadFile">
          <img
            src="@/assets/images/icons/download.svg"
            alt=""
            style="margin-right: 5px"
          />
          Deputatlar listini yuklab olish
        </el-button>

        <el-button
          class="custom-btn header-button"
          @click="$router.push({ name: 'DeputyAdd' })"
          type="primary"
        >
          Qo'shish
        </el-button>

        <el-button
          class="header-button"
          @click="$router.push({ name: 'DeputyAudit' })"
          type="info"
        >
          Audit
        </el-button>
      </div>
    </div>

    <el-table :data="deputies" border height="calc(100vh - 270px)">
      <el-table-column type="index" />
      <el-table-column prop="image_id" label="Rasm" min-width="70">
        <template #default="scope">
          <img
            :src="scope.row.image_id ? baseUrl + scope.row.image_id : defaultAvatar"
            alt="deputy-img"
            class="deputy-img"
          />
        </template>
      </el-table-column>
      <el-table-column prop="fullname" label="Ismi Sharifi" min-width="220" />
      <el-table-column prop="phone_number" label="Telefon raqami" min-width="170" />
      <el-table-column prop="pinfl" label="Pinfl" min-width="160" />
      <el-table-column prop="region_title" label="Viloyat" min-width="180" />
      <el-table-column prop="district_title" label="Tuman/Shahar" min-width="180" />
      <el-table-column label="Mahallalar" min-width="240">
        <template #default="scope">
          {{ formatQuarters(scope.row.quarters) }}
        </template>
      </el-table-column>
      <el-table-column prop="last_login_date" label="So'nggi kirish vaqti" min-width="170">
        <template #default="scope">
          {{
            scope.row.last_login_date
              ? $moment(scope.row.last_login_date).format("DD-MM-YYYY / HH:mm")
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column width="200" label="Tahrirlash/O'chirish" fixed="right">
        <template #default="scope">
          <el-button
            size="small"
            @click="onEditDeputy(scope.row.id)"
            type="primary"
          >
            Tahrirlash
          </el-button>
          <el-button
            size="small"
            @click="onDeleteDeputy(scope.row.id)"
            type="danger"
          >
            O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>Deputatlar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "DeputyList",
  data() {
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/deputies-sync-excel`,
      uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
      baseUrl: `${process.env.VUE_APP_BASE_API_URL}/api/v2/info/file/`,
      defaultAvatar: require("@/assets/images/user-avatar.png"),
      loading: false,
      regionsLoading: false,
      districtsLoading: false,
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      region_id: "",
      district_id: "",
      regions: [],
      districts: [],
      deputies: [],
    };
  },
  methods: {
    getFileName(headers, fallback) {
      const contentDisposition =
        headers?.["content-disposition"] || headers?.["Content-Disposition"];

      if (!contentDisposition) return fallback;

      const fileNamePart = contentDisposition
        .split(";")
        .find((item) => item.trim().startsWith("filename="));

      if (!fileNamePart) return fallback;

      return decodeURIComponent(
        fileNamePart.split("=")[1].trim().replace(/^"(.*)"$/, "$1")
      );
    },
    formatQuarters(quarters) {
      if (!quarters?.length) return "-";
      return quarters.map((item) => item.title).join(", ");
    },
    onChangeRegion() {
      this.district_id = "";
      this.districts = [];
      this.currentPage = 1;
      this.$router.replace({
        query: { ...this.$route.query, page: 1 },
      });
      this.getDistricts();
    },
    onChangeDistrict() {
      this.currentPage = 1;
      this.$router.replace({
        query: { ...this.$route.query, page: 1 },
      });
      this.getDeputiesList();
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions || [];
          this.getDeputiesList();
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },
    getDistricts(shouldFetchList = true) {
      if (!this.region_id) {
        this.districts = [];
        if (shouldFetchList) {
          this.getDeputiesList();
        }
        return;
      }

      this.districtsLoading = true;
      this.$http
        .get("/api/v1/districts", {
          params: {
            region_id: this.region_id,
          },
        })
        .then(({ data }) => {
          this.districts = data.districts || [];
          if (shouldFetchList) {
            this.getDeputiesList();
          }
        })
        .catch(() => {})
        .finally(() => {
          this.districtsLoading = false;
        });
    },
    onSuccessUpload() {
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
      this.getDeputiesList();
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({ name: "Auth" });
      }

      ElNotification.error({
        message:
          JSON.parse(error?.message)?.message ||
          "Amaliyotni bajarishda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring!",
        type: "error",
      });
      this.loading = false;
    },
    onExceed() {},
    downloadFile() {
      this.loading = true;
      this.$http
        .get("api/v1/deputies-excel", {
          responseType: "blob",
        })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.getFileName(res.headers, "deputies.xlsx"));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message:
              response?.data?.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onEditDeputy(id) {
      this.$router.push({ name: "DeputyEdit", params: { id } });
    },
    onDeleteDeputy(id) {
      ElMessageBox.confirm("Deputatni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`/api/v1/deputies/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Deputat o'chirildi",
              });
              this.getDeputiesList();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
    getDeputiesList() {
      this.loading = true;
      this.$http
        .get("/api/v1/deputies", {
          params: {
            region_id: this.region_id || null,
            district_id: this.district_id || null,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.deputies = data.deputies || [];
          this.totalCount = data.count || 0;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange() {
      this.$router.replace({
        query: { ...this.$route.query, page: this.currentPage },
      });
      this.getDeputiesList();
    },
    handleSizeChange() {
      this.$router.replace({
        query: { ...this.$route.query, size: this.limit, page: 1 },
      });
      this.currentPage = 1;
      this.getDeputiesList();
    },
  },
  mounted() {
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
    this.getRegions();
  },
};
</script>

<style scoped>
.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.header {
  display: inline-flex;
  gap: 10px;
  justify-content: flex-end;
  min-width: max-content;
}

.header-control {
  width: 180px;
  flex-shrink: 0;
}

.upload-demo,
.header-button {
  flex-shrink: 0;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.deputy-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
